"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSlotValue = getSlotValue;
exports.slot = slot;
const requestSlotValueToString_1 = require("./requestSlotValueToString");
/**
 * Returns the slot value, if not found it returns undefined.
 *
 * @param slots
 * @param name
 * @returns
 */
function getSlotValue(slots, name) {
    if (!slots) {
        return undefined;
    }
    const value = slots[name];
    return value ? value.value : undefined;
}
/**
 * From the provided slot map, it returns the slot value as a string or an empty string
 * if it doesn't find the value.
 *
 * @param request
 * @param name
 */
function slot(slots, name) {
    const value = getSlotValue(slots, name);
    return value ? (0, requestSlotValueToString_1.requestSlotValueToString)(value) : "";
}
//# sourceMappingURL=getSlotValue.js.map